import React from 'react';
import PropTypes from 'prop-types';

import './SectionSeparator.scss';

const SectionSeparator = ({ title }) => (
  <div className="section-separator">
    <div className="section-separator__line" />
    {title && (
      <div className="section-separator__title">
        {title}
      </div>
    )}
    <div className="section-separator__line" />
  </div>
);

SectionSeparator.propTypes = {
  title: PropTypes.string,
};

SectionSeparator.defaultProps = {
  title: '',
};

export default SectionSeparator;



// WEBPACK FOOTER //
// ./src/routes/Case/Details/components/SectionSeparator/SectionSeparator.js